// Public classes.
export { TruncatePipesModule } from './modules/truncate-pipes.module';
